var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Chart',{staticClass:"mt-5 mt-sm-0",on:{"tooltip":_vm.onTooltip}}),_c('Tooltip',{attrs:{"asset":_vm.asset,"top":_vm.tooltipTop,"left":_vm.tooltipLeft}}),_c('Legend',{on:{"tooltip":_vm.onTooltipLegend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }